import { render, staticRenderFns } from "./RoundAnnouncement.vue?vue&type=template&id=5c0182a4&scoped=true&"
import script from "./RoundAnnouncement.vue?vue&type=script&lang=ts&"
export * from "./RoundAnnouncement.vue?vue&type=script&lang=ts&"
import style0 from "./RoundAnnouncement.vue?vue&type=style&index=0&id=5c0182a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0182a4",
  null
  
)

export default component.exports